<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    :width="width"
    :height="height"
    viewBox="0 0 24 24">
    <title :id="iconName">{{ iconName }} icon</title>
    <defs>
      <path
        id="save-a"
        d="M19 21H5c-1.103 0-2-.897-2-2V5c0-1.104.897-2 2-2h9.586c.534 0 1.036.208 1.414.586L20.414 8c.373.372.586.888.586 1.414V19c0 1.103-.897 2-2 2zM14.586 5L19 9.414 19.001 19H5V5h9.586zM12 12c-1.654 0-3 1.346-3 3s1.346 3 3 3 3-1.346 3-3-1.346-3-3-3zm0 2c.551 0 1 .449 1 1 0 .551-.449 1-1 1-.551 0-1-.449-1-1 0-.551.449-1 1-1zm3-7h-2v3h2V7zm-4 0H7v3h4V7z" />
    </defs>
    <g
      fill="none"
      fill-rule="evenodd">
      <path d="M0 0h24v24H0z" />
      <mask
        id="save-b"
        fill="#fff">
        <use xlink:href="#save-a" />
      </mask>
      <g
        :fill="iconColor"
        mask="url(#save-b)">
        <path d="M0 0h24v24H0z" />
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    iconName: {
      type: String,
      default: "send",
    },
    width: {
      type: [Number, String],
      default: 20,
    },
    height: {
      type: [Number, String],
      default: 21,
    },
    iconColor: {
      type: String,
      default: "currentColor",
    },
  },
};
</script>

<style scoped>
svg {
  display: inline-block;
  vertical-align: baseline;
}
</style>
